import api from '../../../services/Api';
import { IAuditoriaContaTransitoriaResultado } from '../interfaces/IAuditoriaContaTransitoria';

export const AuditoriaContaTransitoriaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaContaTransitoriaResultado> {
    const response = await api.get<IAuditoriaContaTransitoriaResultado>('auditoria-conta-transitoria/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        saldoNaoZerado: [],
        contasConciliadas: [],
      }
    );
  },
};
